import { OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DialogLinkComponent } from './dialog-link/dialog-link.component';
import { TabLinksService } from './tab-links.service';
var TabLinksComponent = /** @class */ (function () {
    function TabLinksComponent(matDialog, tabLinksService, translateService, videoInfoModalService) {
        this.matDialog = matDialog;
        this.tabLinksService = tabLinksService;
        this.translateService = translateService;
        this.videoInfoModalService = videoInfoModalService;
        this.searchControl = new FormControl();
        this.hasLinkedItems = false;
        this.locationLinks = [];
        this.unlinkedEquipments = [];
        this.destroy$ = new Subject();
    }
    TabLinksComponent.prototype.populateLinkedItems = function () {
        var equipments = this.recurrence.equipments;
        var sectors = this.recurrence.locationSectors;
        var environments = this.recurrence.locationEnvironments;
        this.hasLinkedItems = Boolean(environments.length ||
            equipments.length ||
            sectors.length);
        if (!this.hasLinkedItems) {
            return;
        }
        var _a = this.tabLinksService.linkSectorsEnvironmentsEquipments({
            sectors: sectors,
            environments: environments,
            equipments: equipments
        }), sectorsLinks = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
        var locationLinksUnfiltered = this.tabLinksService.formatSectors({
            sectors: sectorsLinks,
            environments: environments,
            equipments: equipments,
            isViewMode: this.isViewMode,
            recurrence: this.recurrence
        });
        var unlinkedEquipmentsUnfiltered = this.tabLinksService.formatUnlinkedEquipments({
            unlinkedEquipments: unlinkedEquipments,
            isViewMode: this.isViewMode,
            recurrence: this.recurrence
        });
        this.locationLinks = this.filter(locationLinksUnfiltered, this.searchControl.value);
        this.unlinkedEquipments = this.filter(unlinkedEquipmentsUnfiltered, this.searchControl.value);
    };
    TabLinksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tabLinksService.unlinkItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (result) {
            _this.clearFormLinks(result);
            _this.populateLinks();
        });
        this.tabLinksService.reloadItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (value) {
            _this.updateFormLinks(value);
            _this.populateLinks();
        });
        this.searchControl.valueChanges
            .pipe(takeUntil(this.destroy$), debounceTime(500))
            .subscribe(function () {
            _this.populateLinks();
        });
        merge(this.form.get('segment').valueChanges, this.form.get('location').valueChanges)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function () {
            _this.populateLinks();
        });
        this.searchControl.setValue('');
    };
    TabLinksComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TabLinksComponent.prototype.openDialogLink = function () {
        var _this = this;
        var segment = this.form.get('segment').value;
        var location = this.form.get('location').value;
        if (!segment || !location) {
            return;
        }
        this.matDialog.open(DialogLinkComponent, {
            panelClass: 'field-dialog-860',
            autoFocus: false,
            data: {
                segmentId: segment.id,
                locationId: location.id,
                linkedEquipments: this.form.get('newEquipments').value,
                linkedSectors: this.form.get('locationSectors').value,
                linkedEnvironments: this.form.get('locationEnvironments').value,
            }
        }).afterClosed().subscribe(function (result) {
            if (result) {
                _this.form.get('newEquipments').setValue(result.equipments);
                _this.form.get('locationSectors').setValue(result.sectors);
                _this.form.get('locationEnvironments').setValue(result.environments);
            }
            _this.searchControl.setValue('');
            _this.populateLinks();
        });
    };
    TabLinksComponent.prototype.updateFormLinks = function (params) {
        var formValue = this.form.get(params.formControlName);
        var index = formValue.value.findIndex(function (item) { return item.id === params.updatedValue.id; });
        formValue.value[index] = params.updatedValue;
        this.form.get(params.formControlName).setValue(formValue.value);
        if (params.updatedValue.archived) {
            formValue.value.splice(index, 1);
            this.clearFormLinks({
                id: params.updatedValue.id,
                formControlName: params.formControlName
            });
        }
        if (params.formControlName = 'newEquipments') {
            var hasEnvironmentOnForm = params.updatedValue.locationEnvironment && this.form.get('locationEnvironments').value
                .some(function (environment) { return environment.id === params.updatedValue.locationEnvironment.id; });
            if (params.updatedValue.locationEnvironment && !hasEnvironmentOnForm) {
                formValue.value.splice(index, 1);
                this.clearFormLinks({
                    id: params.updatedValue.id,
                    formControlName: params.formControlName
                });
            }
            var hasSectorOnForm = params.updatedValue.locationSector && this.form.get('locationSectors').value
                .some(function (sector) { return sector.id === params.updatedValue.locationSector.id; });
            if (params.updatedValue.locationSector && !hasSectorOnForm) {
                formValue.value.splice(index, 1);
                this.clearFormLinks({
                    id: params.updatedValue.id,
                    formControlName: params.formControlName
                });
            }
        }
        this.populateLinks();
    };
    TabLinksComponent.prototype.clearFormLinks = function (params) {
        var maintenanceFormValue = this.form.getRawValue();
        var newValue = maintenanceFormValue[params.formControlName].filter(function (item) { return item.id !== params.id; });
        this.form.get(params.formControlName).setValue(newValue);
        if (params.formControlName === 'locationSectors') {
            var environments = maintenanceFormValue.locationEnvironments.filter(function (environment) { return (environment.locationSector.id !== params.id); });
            var equipments = maintenanceFormValue.newEquipments.filter(function (equipment) { return (!equipment.locationSector || equipment.locationSector.id !== params.id); });
            this.form.get('newEquipments').setValue(equipments);
            this.form.get('locationEnvironments').setValue(environments);
        }
        if (params.formControlName === 'locationEnvironments') {
            var equipments = maintenanceFormValue.newEquipments.filter(function (equipment) { return (!equipment.locationEnvironment || equipment.locationEnvironment.id !== params.id); });
            this.form.get('newEquipments').setValue(equipments);
        }
    };
    TabLinksComponent.prototype.populateLinks = function () {
        var equipments = this.form.get('newEquipments').value || [];
        var sectors = this.form.get('locationSectors').value || [];
        var environments = this.form.get('locationEnvironments').value || [];
        this.hasLinkedItems = Boolean((equipments && equipments.length) ||
            (sectors && sectors.length) ||
            (environments && environments.length));
        var searchValue = this.searchControl.value && this.searchControl.value.trim().toLowerCase();
        var _a = this.tabLinksService.linkSectorsEnvironmentsEquipments({
            sectors: sectors,
            environments: environments,
            equipments: equipments
        }), sectorsLinks = _a.sectors, unlinkedEquipments = _a.unlinkedEquipments;
        var locationLinksUnfiltered = this.tabLinksService.formatSectors({
            sectors: sectorsLinks,
            environments: environments,
            isViewMode: this.isViewMode,
            equipments: equipments
        });
        var unlinkedEquipmentsUnfiltered = this.tabLinksService.formatUnlinkedEquipments({
            unlinkedEquipments: unlinkedEquipments,
            isViewMode: this.isViewMode,
        });
        this.locationLinks = this.tabLinksService.filter(locationLinksUnfiltered, searchValue);
        this.unlinkedEquipments = this.tabLinksService.filter(unlinkedEquipmentsUnfiltered, searchValue);
    };
    TabLinksComponent.prototype.openDemonstrationVideoDialog = function () {
        this.videoInfoModalService.open({
            title: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.TITLE'),
            description: this.translateService.instant('MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.INTRO_VIDEO.DESCRIPTION'),
            videoId: 'VQE_FyV8Gf0'
        });
    };
    TabLinksComponent.prototype.filter = function (items, searchTerm) {
        var _this = this;
        searchTerm = (searchTerm || '').toLowerCase().trim();
        return items.filter(function (item) {
            if (item.children) {
                item.children = _this.filter(item.children, searchTerm);
            }
            var text = (item.text || '').toLowerCase();
            var description = (item.description || '').toLowerCase();
            return text.includes(searchTerm) || description.includes(searchTerm) || (item.children && item.children.length) || _this.parentMatch(item, searchTerm);
        });
    };
    TabLinksComponent.prototype.parentMatch = function (item, searchTerm) {
        if (!item.parent) {
            return false;
        }
        searchTerm = (searchTerm || '').toLowerCase().trim();
        var text = (item.parent.text || '').toLowerCase();
        var description = (item.parent.description || '').toLowerCase();
        return text.includes(searchTerm) || description.includes(searchTerm) || this.parentMatch(item.parent, searchTerm);
    };
    return TabLinksComponent;
}());
export { TabLinksComponent };
